import React, {useCallback, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Button,
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardHeader,
	DialogActions,
	Paper,
	TextField,
	Tooltip,
	Typography
} from "@mui/material";
import clsx from "clsx";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import {ContattaciStyle} from "../../../../styles/pages/contact/ContattaciStyle";
import {useHistory} from "react-router-dom";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import {useForm} from "react-hook-form";
import CustomText from "../../../widgets/inputs/CustomText";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import { Autocomplete } from '@mui/material';
import {PaperComponent} from "../../../../styles/components/DynamicComponentStyle";

const AllIstitutiCard = ({showButton = true}) => {
	const classes = BaseStyle();
	const history = useHistory();
	const contattaciClasses = ContattaciStyle();
	const [value, setValue] = useState("");
	const [progetti, setProgetti] = useState([]);
	const [open, setOpen] = useState(false);
	const [tags, setTags] = useState([]);
	const [ordiniScuola, setOrdiniScuola] = useState([]);
	const {register, handleSubmit, errors, control} = useForm({mode: "onChange"});

	const onSubmit = useCallback((data) => {
		console.log(data);
		axios
			.post('/ocean-scuole-api/API/scuole/progetti/create', {
				...data,
				tag: tags.join(',') + ',' + ordiniScuola.join(','),
				enable: true
			}, getConfig())
			.then(() => {
				alert('progetto creato con successo!');
				setOpen(false);
			})
			.catch((error) => alert(JSON.stringify(error)))
	}, [tags, ordiniScuola])

	const handleCreateTag = event => {
		switch (event.key) {
			case ",":
			case "Enter":
			case "Alt":
			case "Tab": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, event.target.value]);
				}
				break;
			}
			default:
		}
	};

	useEffect(() => {
		axios
			.post('/ocean-scuole-api/API/scuole/progetti/getAll', {
				enable: null,
			}, getConfig())
			.then((res) => {
				if (res.status !== 226) {
					setProgetti(res.data);
				}
			})
	}, [open])

	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Tutti i progetti</b></Typography>}
					subheader={"Visualizza tutti i progetti presenti e clicca su di essi per modificarli"}
				/>
				<CardContent style={{flexGrow: 1}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper className={clsx(classes.roundBorder)} component={"section"}>
								<TextField
									placeholder={"Cerca per nome"}
									value={value}
									onChange={event => setValue(event.target.value)}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder}
									}}
								/>
							</Paper>
						</Grid>
						<Grid item xs={12} className={classes.flexStart}>

							{
								progetti.length === 0 && <p>Non ci sono progetti...</p>
							}

							{
								progetti
									.filter(item => item.titolo?.toUpperCase()?.includes(value?.toUpperCase()) || value?.toUpperCase()?.includes(item.titolo?.toUpperCase()))
									.map((progetto, index) => {
										return (
											<Card key={index} className={clsx(classes.roundBorder, classes.margin1, classes.classActionCard)}
											      style={{height: "auto"}}>
												<Tooltip title={"Clicca per visualizzare e modificare il progetto"}>
													<CardActionArea
														onClick={() => window.open(`https://salute.aslcittaditorino.it/scuole/progetto/${progetto.id}`, '_blank').focus()}>
														<CardHeader
															style={{height: 50}}
															title={<Typography variant={"subtitle1"}><b>{progetto.titolo}</b></Typography>}
														/>
														<CardContent style={{
															height: 200,
															paddingBottom: 4,
															overflowY: "scroll",
															marginTop: 0,
															paddingTop: 0
														}}>
															<Typography variant={"body2"}>
																{progetto.descrizione}
															</Typography>
														</CardContent>
													</CardActionArea>
												</Tooltip>
											</Card>
										)
									})
							}


						</Grid>
					</Grid>
				</CardContent>
				<CardActions className={classes.flexRight}>
					{showButton && <Tooltip title={"Visualizza tutti i progetti"}>
						<Button size={"small"} variant={"text"} disableElevation
						        onClick={() => history.push("/gestione/scuole/progetti")}
						        className={classes.roundButton}>
							<b>Visualizza tutti</b>
						</Button>
					</Tooltip>}
					<Tooltip title={"Crea un istituto"}>
						<Button size={"small"} variant={"contained"} disableElevation color={"primary"}
						        className={classes.roundButton} onClick={() => setOpen(true)}>
							<b>Crea</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
            {
				open &&
				<SimpleDialog
					maxWidth={'lg'}
					open={open}
					handleClose={() => setOpen(!open)}
					title={"Crea progetto"}
					content={
						<form onSubmit={handleSubmit(onSubmit)}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"titolo"}
										label={"Titolo progetto"}
										autoFocus={true}
										error={errors["titolo"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={register({required: true})}
										rows={4}
										name={"descrizione"}
										label={"Descrizione sintetica"}
										error={errors["descrizione"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"servizioAslProponente"}
										label={"Servizio A.S.L. proponente"}
										autoFocus={true}
										error={errors["servizioAslProponente"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"altriAttori"}
										label={"Altri attori"}
										autoFocus={true}
										error={errors["altriAttori"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<Autocomplete
										multiple
										freeSolo
										options={['Scuola dell\' Infanzia', 'Scuola Primaria', 'Scuola Secondaria di 1° grado', 'Scuola Secondaria di 2° grado']}
										getOptionLabel={option => option || option}
										value={ordiniScuola}
										onChange={(event, newValue) => setOrdiniScuola(newValue)}
										filterSelectedOptions
										PaperComponent={PaperComponent}
										renderInput={params => {
											params.inputProps.onKeyDown = handleCreateTag;
											return (
												<TextField
													{...params}
													variant="outlined"
													label="Ordini di scuola a cui è rivolto"
													fullWidth
												/>
											);
										}}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={register({required: true})}
										rows={4}
										name={"finalita"}
										label={"Finalità del progetto"}
										error={errors["finalita"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"destinatariIntermedi"}
										label={"Destinatari intermedi"}
										autoFocus={true}
										error={errors["destinatariIntermedi"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"destinatariFinali"}
										label={"Destinatari finali"}
										autoFocus={true}
										error={errors["destinatariFinali"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={register({required: true})}
										rows={4}
										name={"metodologie"}
										label={"Metodologie"}
										error={errors["metodologie"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={register({required: true})}
										rows={4}
										name={"riferimentiBibliografici"}
										label={"Riferimenti bibliografici"}
										error={errors["riferimentiBibliografici"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"durata"}
										label={"Durata"}
										autoFocus={true}
										error={errors["durata"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomMultiText
										inputRef={register({required: true})}
										rows={4}
										name={"fasiOperative"}
										label={"Fasi operative"}
										error={errors["fasiOperative"]}
									/>
								</Grid>
								<Grid item xs={12}>
									<CustomText
										control={control}
										rules={{required: true}}
										name={"prodottoFinale"}
										label={"Prodotto finale"}
										autoFocus={true}
										error={errors["prodottoFinale"]}
									/>
								</Grid>


								<Grid item xs={12}>
									<Autocomplete
										multiple
										freeSolo
										options={['Alimentazione', 'Consumi e comportamenti a rischio', 'Incidenti', 'Lifeskills', 'Salute mentale e benessere psicofisico',
											'Sessualità', 'Per gli insegnanti', 'Peer education', 'Altre proposte']}
										getOptionLabel={option => option}
										value={tags}
										onChange={(_event, newValue) => setTags(newValue)}
										filterSelectedOptions
										PaperComponent={PaperComponent}
										renderInput={params => {
											params.inputProps.onKeyDown = handleCreateTag;
											return (
												<TextField
													{...params}
													variant="outlined"
													label="TAG / Aree tematiche"
													fullWidth
												/>
											);
										}}
									/>
								</Grid>
							</Grid>
						</form>
					}
					actions={
						<DialogActions>
							<Button onClick={handleSubmit(onSubmit)} className={classes.roundButton} disableElevation
							        style={{borderRadius: 22}} variant={"contained"} size={"small"} color={"primary"}>
								<b>Crea</b>
							</Button>
						</DialogActions>
					}
				/>
			}
        </React.Fragment>
    );
};

export default React.memo(AllIstitutiCard)
